export default {
  summaryLine: '{series} series · {rows} rows',
  startDateHelp: 'Each row is counted in the period that contains its Start Date. Periods with no rows are left empty, not shown as zero.',
  week: 'Weekly',
  month: 'Monthly',
  quarter: 'Quarterly',
  year: 'Yearly',
  metric: 'Metric',
  filter: 'Filter',
  variable: 'Variable',
  allVariables: 'All variables',
  byVariable: 'By variable',
  allData: 'All data',
  blankValue: '(blank)',
  filterUnavailableValues: 'Too many values to filter',
  filterUnavailableSize: 'Not available for a template this size',
  flaggedOnly: 'Only series to review',
  showSpecialDates: 'Show special dates',
  fixedDims: 'Every row has {list}',
  bucketedNotice: 'This sheet has daily data, so the most detailed view is weekly.',
  noSeries: 'No series match this selection',
  coverageTitle: 'Coverage',
  coverageHelp: 'Each row is a series and each column a period. Darker cells are higher values within that series; white cells are periods with no data. Look for gaps and for series that start or end at odd dates.',
  coverageHelpByBrand: 'Each row is a competitor (all its media added up) and each column a period. Darker cells are higher values within that competitor; white cells are periods with no data. Look for gaps and for competitors that start or end at odd dates.',
  seriesTitle: 'Series',
  showMore: 'Show {count} more',
  issueMissingColumns: 'Columns not found: {list}',
  issueBadDates: '{count} rows were skipped because their Start Date could not be read.',
  issueTextDates: '{count} rows have dates typed as text. Check that days and months are not swapped.',
  issueNonNumeric: '{count} values are not numbers and were left out.',
  issueDroppedSeries: 'Showing the {shown} series with the most rows ({hidden} more are not shown).'
}
